import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
interface ProfileCardProps {
  profile: {
    profile: string;
    title: string;
    description: string;
    recommendations: string[];
  };
}
const ProfileCard: React.FC<ProfileCardProps> = ({
  profile
}) => {
  // Map profile to background image
  const getProfileImage = () => {
    switch (profile.profile) {
      case 'erection':
        return 'https://images.unsplash.com/photo-1534438327276-14e5300c3a48?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1740&q=80';
      case 'libido':
        return 'https://images.unsplash.com/photo-1534438327276-14e5300c3a48?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1740&q=80';
      case 'energy':
        return 'https://images.unsplash.com/photo-1534438327276-14e5300c3a48?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1740&q=80';
      case 'balance':
        return 'https://images.unsplash.com/photo-1534438327276-14e5300c3a48?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1740&q=80';
      default:
        return 'https://images.unsplash.com/photo-1534438327276-14e5300c3a48?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1740&q=80';
    }
  };
  return <div className="bg-gray-900 rounded-xl overflow-hidden shadow-lg" data-id="element-289">
      <div className="relative h-48" data-id="element-290">
        <img src={getProfileImage()} alt={profile.title} className="w-full h-full object-cover" data-id="element-291" />
        <div className="absolute inset-0 bg-gradient-to-t from-gray-900 to-transparent" data-id="element-292"></div>
        <div className="absolute bottom-0 left-0 p-6" data-id="element-293">
          <h3 className="text-2xl font-bold" data-id="element-294">{profile.title}</h3>
        </div>
      </div>
      <div className="p-6" data-id="element-295">
        <h4 className="text-xl font-semibold text-[#0EB7FF] mb-4" data-id="element-296">
          {profile.description}
        </h4>
        <div className="space-y-4 mb-6" data-id="element-297">
          {profile.recommendations.map((recommendation, index) => <div key={index} className="flex items-start" data-id="element-298">
              <div className="mr-3 mt-1 text-[#10C96C]" data-id="element-299">✓</div>
              <p data-id="element-300">{recommendation}</p>
            </div>)}
        </div>
        <div className="p-4 bg-gray-800 rounded-lg mb-6" data-id="element-301">
          <h4 className="font-medium mb-2 text-[#0EB7FF]" data-id="element-302">
            VeeloBooster och testosteron
          </h4>
          <p className="text-sm text-gray-300" data-id="element-303">
            VeeloBooster innehåller naturliga ingredienser som hjälper till att
            öka din testosteronproduktion. Högre testosteronnivåer bidrar till
            förbättrad sexlust, ökad energi och bättre muskeltillväxt, vilket
            ger dig en starkare kropp och bättre prestation i sängen.
          </p>
        </div>
        <a href="https://www.fasttrack39.com/Q2F67GN8/2K64K71K/" className="inline-flex items-center px-6 py-3 bg-[#0EB7FF] hover:bg-[#0EA7EF] text-black font-semibold rounded-md transition-all" data-id="element-304">
          Prova VeeloBooster nu
          <ArrowRightIcon className="w-4 h-4 ml-2" data-id="element-305" />
        </a>
      </div>
    </div>;
};
export default ProfileCard;